import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hknrr7uh5: FaireProductEntity = {
  token: "p_8hknrr7uh5",
  type: "product",
  name: "Little Notes® Envelopes - Ocean - Set of 20",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9387f9f793aef5a48efc2887052b43db2386f9bb2c989de0a096196da1ccdb8c.jpeg",
  galleryImageUrls: [],
  priceDollars: 5,
  description:
    "Round out your Little Notes® collection with our Little Notes® Envelopes: a set of 20 tiny envelopes, each just the right size for a single Little Note. Perfect for a tip, a secret note, or to add a gummy bear to sweeten the love. These petite envelopes turn every Little Note into a secret surprise.\n\nPlease note: These envelopes are so adorably tiny that they're too small for the postal service, so hand-deliver only!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:13.248Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
